<template>
    <div class="product-insights">
      <carousel :per-page="5" :navigationEnabled="true" :mouse-drag="false">
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Engagement:</h3>
                <h2 style="text-align: left;font-size: 18px;margin-top: 20px; margin-bottom: 0px;">{{  Math.round((totalTimeMinutes /60) + (totalHomeTaskTime /60) + (totalDealDropTime / 60)) }} Hr</h2>
              </div>
            </div>
          </div>
        </slide>
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Total Activities Engagement Time (GEO):</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ totalTimeMinutes / 60 ? Math.ceil(totalTimeMinutes / 60) : 0 }} Hr</h2>
              </div>
            </div>
          </div>
        </slide> -->
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Avg Activity Engagement Time (GEO):</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ avgEngagementMinutes ? Math.ceil(avgEngagementMinutes) : 0 }} Minutes</h2>
              </div>
              </div>
            </div>
        </slide> -->
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Total Activities Engagement Time (NON GEO):</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ totalHomeTaskTime / 60 ? Math.ceil(totalHomeTaskTime / 60) : 0 }} Hr</h2>
              </div>
            </div>
          </div>
        </slide> -->
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Avg Activity Engagement Time (NON GEO):</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ avgHomeTaskTime ? Math.ceil(avgHomeTaskTime) : 0 }} Minutes</h2>
              </div>
              </div>
            </div>
        </slide> -->

        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Product interactions:</h3>
                <h2 style="text-align: left;font-size: 18px;margin-top: 20px; margin-bottom: 0px;">{{Math.round((productTotalTimeMinutes / 60) + (homeTaskMediaTime /60) + (totalSelfies /60))}} Hr</h2>
              </div>
              </div>
            </div>
        </slide>
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Avg Product Intraction Time:</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ productAvgEngagementMinutes ? Math.ceil(productAvgEngagementMinutes) : 0 }} Minutes</h2>
              </div>
              </div>
            </div>
        </slide> -->
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Survey:</h3>
                <h2 style="text-align: left;font-size: 18px;margin-top: 20px; margin-bottom: 0px;">{{ surveyTotalTimeMinutes / 60 ? Math.ceil(surveyTotalTimeMinutes / 60) : 0 }} Hr</h2>
              </div>
              </div>
            </div>
        </slide>
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Avg Survey Time:</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ surveyAvgEngagementMinutes ? Math.ceil(surveyAvgEngagementMinutes) : 0 }} Minutes</h2>
              </div>
              </div>
            </div>
        </slide> -->
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Media:</h3>
                <h2 style="text-align: left;font-size: 18px;margin-top: 20px; margin-bottom: 0px;">{{  Math.round((homeTaskMediaTime /60) + (totalSelfies /60)) }} Hr</h2>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Deal Drop:</h3>
                <h2 style="text-align: left;font-size: 18px;margin-top: 20px; margin-bottom: 0px;">{{  Math.round((totalDealDropTime /60)) }} Hr</h2>
              </div>
              </div>
            </div>
        </slide>
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Avg Media Time:</h3>
                <h2 style="text-align: left;font-size: 16px;">0 Minutes</h2>
              </div>
              </div>
            </div>
        </slide> -->
      </carousel>
      <!-- <h4 v-show="loading" style="text-align: center;">Loading Products Insights...</h4> -->
    </div>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ProductInsights',
  components: {
    Carousel,
    Slide
  },
  props: ['brandId', 'totalTimeMinutes', 'totalDealDropTime', 'homeTaskMediaTime', 'totalSelfies', 'totalHomeTaskTime', 'avgHomeTaskTime', 'productTotalTimeMinutes', 'surveyAvgEngagementMinutes', 'surveyTotalTimeMinutes', 'productAvgEngagementMinutes', 'avgEngagementMinutes', 'fastestActivityMinutes', 'slowestActivityminutes'],
  data: function () {
    return {
      loading: true,
      localTime: '',
      selfies: [],
      image: '',
      userName: '',
      storeName: '',
      storeAddress: '',
      slickOptions: {
        slidesToShow: 3
      }
    }
  },
  methods: {
    next () {
      this.$refs.slick.next()
    },

    prev () {
      this.$refs.slick.prev()
    },

    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },

    handleAfterChange (event, slick, currentSlide) {
      console.log('handleAfterChange', event, slick, currentSlide)
    },
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
      console.log('handleBeforeChange', event, slick, currentSlide, nextSlide)
    },
    handleBreakpoint (event, slick, breakpoint) {
      console.log('handleBreakpoint', event, slick, breakpoint)
    },
    handleDestroy (event, slick) {
      console.log('handleDestroy', event, slick)
    },
    handleEdge (event, slick, direction) {
      console.log('handleEdge', event, slick, direction)
    },
    handleInit (event, slick) {
      console.log('handleInit', event, slick)
    },
    handleReInit (event, slick) {
      console.log('handleReInit', event, slick)
    },
    handleSetPosition (event, slick) {
      console.log('handleSetPosition', event, slick)
    },
    handleSwipe (event, slick, direction) {
      console.log('handleSwipe', event, slick, direction)
    },
    handleLazyLoaded (event, slick, image, imageSource) {
      console.log('handleLazyLoaded', event, slick, image, imageSource)
    },
    handleLazyLoadError (event, slick, image, imageSource) {
      console.log('handleLazeLoadError', event, slick, image, imageSource)
    },

    getBrandSocialSelfies () {
      this.$store.dispatch('getBrandSocialSelfies', this.brandId)
        .then(
          (response) => {
            // console.log(response.body)
            this.selfies = response.body
            this.loading = false
            this.showLocaleTime()
            this.image = this.selfies[0]['image'] + '?width=300'
            this.storeAddress = this.selfies[0]['address']
            this.userName = this.selfies[0]['name']
            this.storeName = this.selfies[0]['store']
          }
        )
    },
    showLocaleTime: function () {
      var here = this
      let counter = 1
      setInterval(function () {
        here.image = here.selfies[counter]['image'] + '?width=300'
        here.storeAddress = here.selfies[counter]['address']
        here.userName = here.selfies[counter]['name']
        here.storeName = here.selfies[counter]['store']
        counter++
        if (counter === (here.selfies.length - 1)) {
          counter = 0
        }
      }, 5000)
    }
  },

  mounted () {
    // this.getBrandSocialSelfies()

  },
  watch: {
  }
}
</script>
<style>
.VueCarousel-pagination{
  display: none;
}
.metrics-box {
    width: 94%;
    margin: 10px 3%;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
    padding: 10px;
    text-align: center;
    min-height: 100px !important;
}
.metrics-box h3{
    font-size: 14px;
    color: #000;
    line-height: 23px;
}
.metrics-box h2{
    font-size: 20px;
    color: #000;
    line-height: 23px;
    min-height: 23px;
}
.metrics-box h5{
    background: #d2eadd;
    width: 52px;
    line-height: 50px;
    border-radius: 100%;
    margin-top: 20px;
    border: 2px solid #12db6d;
    font-size: 16px;
}
.brown_line{
  border: 2px solid #641c44 !important;
  background: #DCC8D3 !important;
}
</style>
